import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const TasksHeaders = ({ sortBy, sortKey, sortDesc, sourceTypeTitle }) => {
  const namePrefix = sourceTypeTitle === "Administrators" ? "admin" : "agent";
  return (
    <>
      <TR>
        <TD colSpan="7" className="tw-bg-white tw-text-14d tw-font-semibold">
          {sourceTypeTitle}
        </TD>
      </TR>
      <TR>
        <ReportHeader
          name={`${namePrefix}_agent`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Name"
          handleSort={sortBy}
        />
        <ReportHeader
          name={`${namePrefix}_assigned_task_count`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Assigned Tasks"
          handleSort={sortBy}
        />
        <ReportHeader
          name={`${namePrefix}_completed_task_count`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Completed Tasks"
          handleSort={sortBy}
        />

        <ReportHeader
          name={`${namePrefix}_on_time_task_count`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Completed On Time"
          handleSort={sortBy}
        />
        <ReportHeader
          name={`${namePrefix}_late_task_count`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Completed Late"
          handleSort={sortBy}
        />

        <ReportHeader
          name={`${namePrefix}_login_count`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="# Logins"
          handleSort={sortBy}
        />
        <ReportHeader
          name={`${namePrefix}_last_login`}
          sortDesc={sortDesc}
          sortKey={sortKey}
          label="Last Login"
          handleSort={sortBy}
        />
      </TR>
    </>
  );
};

TasksHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
  sourceTypeTitle: PropTypes.string.isRequired,
};

export default TasksHeaders;
